import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Button, Typography, Box, Drawer } from '@mui/material';
import logo from "../../Assets/img/Login/logo.png"
import UserInformation from './UserInformation/UserInformation';
import { styled } from '@mui/material/styles';
import PurposeInterestsNotifications from './UserInformation/PurposeInterestsNotifications';
import AdjustIcon from '@mui/icons-material/Adjust';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UserType from './UserInformation/UserType';
import HeaderSec from '../../Components/HeaderSec/HeaderSec';
import FooterComp from '../../Components/FooterComp/FooterComp';
import OfferEventCampaign from './UserInformation/OfferEventCampaign';
import { useMediaQuery, useTheme } from '@mui/material';



const steps = ['User Information', 'Purpose, Interests & Notifications', 'User Type' , 'Provide details of your offer, event, campaign, if any'];
const DotStepIcon = styled('div')(({ theme, active, completed }) => ({
    
    
  }));
  const DotStepIcon2 = ({ active, completed }) => (
    <DotStepIcon active={active} completed={completed}>
      <AdjustIcon sx={{ color: active || completed ? '#004878' : '#ccc' , fontSize:'30px' , display:completed ? 'none' :'block'}} />
      <CheckCircleIcon sx={{ color: active || completed ? '#004878' : '#ccc' , fontSize:'30px' , display:completed ? 'block' :'none'}} />
    </DotStepIcon>
  );

const CreateAccountMainPage = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [activeStep, setActiveStep] = useState(0);

    const getStepContent = (step) => {
        switch (step) {
        case 0:
            return (
                <div>
                    <UserInformation setActiveStep={setActiveStep}/>
                </div>);
        case 1:
            return (
                <div>
                    <PurposeInterestsNotifications setActiveStep={setActiveStep}/>
                </div>);
        case 2:
            return (
                <div>
                    <UserType setActiveStep={setActiveStep}/>
                </div>);
        case 3:
            return (
                <div>
                    <OfferEventCampaign setActiveStep={setActiveStep}/>
                </div>);
        default:
            return <Typography>Unknown step</Typography>;
        }
    };

  return (
    <>
    <HeaderSec/>
    <div className='flex text-black'>
        {!isMobile &&<Drawer
            className="z-[12]"
            variant="permanent"
            open={true}
            sx={{
                width: '500px',
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: '500px',
                    boxSizing: 'border-box',
                    borderRight: 'none',
                    padding: '30px',
                    position: 'sticky', // So it's not fixed
                    height: '100vh',       // Allow it to grow with content
                    maxHeight: '100%',    // Prevent overflow
                    overflowY: 'auto',    // Scroll inside if content exceeds
                    backgroundColor: '#f4f5f5',
                    borderRadius: '0 30px 30px 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
            }}
        >
            <Box
            sx={{
                padding: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            >
            <img src={logo} alt="Logo" width="180px" />
            </Box>
        </Drawer>}
        <Box sx={{ width: '100%'  ,  padding:'40px 25px'  ,flexGrow:1 }}>
            <Box sx={{width:'100%'}}>

                <Typography variant='h5' className='text-center' sx={{fontWeight:600 , color:'#004878', marginBottom:'30px'}}>Create New Account</Typography>

                <Stepper activeStep={activeStep} sx={{ marginBottom: 2 }} alternativeLabel>
                    {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={DotStepIcon2}>{label}</StepLabel>
                    </Step>
                    ))}
                </Stepper>
                <Box>
                    {/* This is where the content for each step is rendered */}
                    <Box sx={{ marginBottom: 2 }}>
                        {getStepContent(activeStep)}
                    </Box>
                
                </Box>
            </Box>
        </Box>
    </div>
    <FooterComp/>
    </>
  )
}

export default CreateAccountMainPage